import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

import { DireccionComponent, validar as validarDireccion } from "../direccion/direccion";
import { DatosFacturacionNuevoClienteComponent } from "./facturacion";
import { validarIdentificacion } from "app/logic/cliente";
import { IdentificacionComponent } from "app/features/componentes/cliente/identificacion";

type Entity = models.NuevoClienteDocumentacion;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    contactoObligatorio: boolean;
}

/**
* Valida un NuevoViajeRevisionCobranzaMo
*/
export function validar(x: Entity, contactoObligatorio: boolean) {
    const ruleIdentificacion = async (x: models.Identificacion) => {
        const val = await validarIdentificacion(x, {}, resources.Cliente);
        return val;
    }; 

    var IdentidadObligatorio= (x.Facturacion == undefined);// se establece si el formulario  "Identificacion" es obligatoria  
    const rules: validation.Rules<Entity> = {
        Nombre: validation.required,
        Contacto: (x: Entity) => {
            if(x.Contacto == null || x.Contacto == "") {
                return "Obligatorio";
            }
            if(x.Contacto == x.Nombre && x.Identificacion.TipoPersona == models.TipoPersona.Moral) {
                //Si es persona moral el nombre y el contacto no deben de ser iguales
                return "No debe de ser igual al nombre si es persona moral";
            }
            //No hay error
            return true;
        },
        Identificacion: x =>  (IdentidadObligatorio)? true : ruleIdentificacion(x.Identificacion),
        Direccion: validation.subrule(validarDireccion)
    };
    return validation.getErrors(rules, x);
}


/**
* Componente para editar un nuevo cliente de documentación
*/
export class NuevoClienteDocumentacionComponent extends React.PureComponent<Props> { 
    value = (props: Props) => props.value;
    contactoObligatorio = (props: Props) => props.contactoObligatorio;
    errors = createSelectorRx(this.value, this.contactoObligatorio, (x, contactoObligatorio) => validar(x, contactoObligatorio));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    private handleFacturar = (x: boolean) => {
        this.props.onChange({ ... this.props.value, Facturacion: (x ? { Direccion: {} } : undefined) as models.DatosFacturacionNuevoCliente });
    }

    copiarNombreEnContacto=()=>{
        const modelo = this.props.value;
        const nombretxt = this.props.value.Nombre;
        const cambio= {... modelo, Contacto: nombretxt};
        this.props.onChange({ ... cambio});
    }


    render() {  
        const { value } = this.props;
        const getField = this.getField; 
        const Text = getField(kea.Text);
        const Checkbox = getField(kea.Checkbox);
        const Direccion = getField(DireccionComponent);
        const Facturacion = getField(DatosFacturacionNuevoClienteComponent);
        const Identificacion = getField(IdentificacionComponent);
        return (
            <div>
                {kea.autogrid(6, [
                    <div>
                        {kea.autogrid(6, [ 
                         <Text field="Nombre" /> , 
                         <Text field="Contacto" />, 
                         <div></div>, 
                         <kea.Button onClick={() =>this.copiarNombreEnContacto()}>Copiar Nombre</kea.Button> ,


                        ])}
                      
                        <Direccion field="Direccion" />
                    </div>,
                    <div>
                        <Identificacion field="Identificacion" datosRep={{}} resourceRep={resources.Cliente} ocultarRFC={value.Facturacion == null} />
                        {kea.autogrid(6, [
                            <kea.Checkbox label="Facturar" value={value.Facturacion != null} onChange={this.handleFacturar} />,
                            <Checkbox field="AceptaFletePorCobrar" label="Acepta flete por cobrar"  />,
                            //<Checkbox field="SeguroViaje" label="Cobrar seguro de viaje"  />,
                            //<Text field="NumeroPoliza" label="Numero de póliza del cliente"  />,
                            //<Checkbox field="ImprimirPrecioGuia" label="imprimir precio en guias"  />,
                        ])}
                        {value.Facturacion != null &&
                            <div className="row">
                                <div className="col-md-12">
                                    <Facturacion field="Facturacion" nuevoCliente={value}   />
                                </div>
                            </div>
                        }
                    </div>
                ])}
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/componentes/nuevoclientedocumentacion/view.tsx